import React from 'react';

import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';

import HelpIcon from '@mui/icons-material/Help';

import { RowContainer } from './styledInfoComponents';

interface Props {
    label: React.ReactNode;
    border?: boolean;
    showSentryMsg?: boolean;
}

const InfoRow = (props: React.PropsWithChildren<Props>) => {
    return (
        <RowContainer border={props.border}>
            <Typography display="flex" alignItems="center" gap={1}>
                <span>{props.label}</span>
                {props.showSentryMsg && (
                    <Tooltip title="Available with Sentry Plus">
                        <HelpIcon fontSize="small" sx={{ color: '#B4B4B4' }} />
                    </Tooltip>
                )}
            </Typography>
            <Typography fontWeight="bold" whiteSpace="pre-wrap" maxHeight={80}>
                {props.children}
            </Typography>
        </RowContainer>
    );
};

export default InfoRow;
